import * as metaStateUtils from '../../../../store/util/metaStateUtils';


/**
 * @param state {object} Domain state
 * @param carts {array} Carts payload
 * @returns {object} Updated domain state
 */
export default (state, carts) => {

    const cartsById = {};
    carts.forEach(cart => {
        cartsById[cart.id] = cart;
    });

    state.carts = metaStateUtils.setIsLoaded(cartsById);

    return state;
};
